import $ from 'jquery';
const cleanDocument = function (html) {
  // eslint-disable-next-line jquery-unsafe/no-html
  let $content = $('<div>').html(html);
  let content = $content[0];
  let nodes = content.childNodes;
  //First pass to remove the empty block level nodes and disallowed elements
  for (let i = 0, length = nodes.length; i < length; i++) {
    let node = nodes[i];
    if (!$(node).text().length || /META|LINK|STYLE|TITLE/.test(node.tagName)) {
      content.removeChild(node);
      length--;
    }
  }
  //2nd pass to remove the empty text nodes from nodes the removed previously
  for (let j = 0, len = nodes.length; j < len; j++) {
    let child = nodes[j];
    if (child.nodeType === child.TEXT_NODE) {
      content.removeChild(child);
      len--;
    }
  }
  return $.trim($content.html());
};
export default function (html) {
  return /content="Cocoa HTML Writer"/gi.test(html) ? cleanDocument(html) : html;
}